<template>
    <div class="c-field_attachments">
        <h4 class='c-field_attachments__title'>{{ title }}</h4>
        <div class="c-field_attachments__upload">
            <form-upload
                :progress="uploadProgress"
                @upload="uploadFiles"
                speech-to-text>
            </form-upload>
        </div>

        <v-table
            v-if="value && value.length"
            class="c-field_attachments__list">
            <thead>
            <th>Nazwa</th>
            <th>Typ</th>
            <th>Wielkość</th>
            <th>Akcje</th>
            </thead>
            <tbody>
            <tr
                v-for="file in value"
                :key="file.id">
                <td>{{ file.description }}</td>
                <td>{{ file.extension }}</td>
                <td>{{ humanFileSize(file.size) }}</td>
                <td class="c-field_attachments__list-btns">
                    <v-btn
                        type="icon"
                        icon="delete"
                        title="Usuń załącznik"
                        @click="$refs.visitAttachmentsRemoveModal.$emit('open', file.id, type)">
                    </v-btn>
                    <v-btn
                        type="icon"
                        icon="download"
                        title="Pobierz załącznik"
                        @click="downloadFile(file)">
                    </v-btn>
                </td>
            </tr>
            </tbody>
        </v-table>
        <visit-attachments-remove-modal ref="visitAttachmentsRemoveModal"></visit-attachments-remove-modal>
    </div>
</template>


<script>

import {mapGetters} from 'vuex'
import {FormUpload} from 'Components/Form'
import VTable from 'Components/VTable'
import VBtn from 'Components/VBtn'
import FileDownload from 'js-file-download'
import VisitAttachmentsRemoveModal from 'Components/Visit/VisitAttachmentsRemoveModal'

export default {

    name: 'VisitFieldAttachments',

    props: {
        value: Array,
        type: String,
        label: String,
        title: String
    },

    data() {
        return {
            files: [],
            uploadProgress: 0
        }
    },

    methods: {
        save(nextSection) {
            nextSection()
        },
        uploadFiles(file, afterUpload) {
            let data = {
                type: this.type,
                data: file,
                onProgress: (progress) => {
                    this.uploadProgress = progress
                }
            }
            this.$store.dispatch('VISIT_ATTACHMENTS_UPLOAD', data).then((response) => {
                afterUpload()
                this.uploadProgress = 0
                this.$alert.success('Załączniki', response.data.message, 2000)
            }).catch((error) => {
                afterUpload()
                this.$alert.error('Załączniki', error.response.data.message)
            })
        },
        downloadFile(file) {
            this.$store.dispatch('VISIT_ATTACHMENTS_DELETE_DOWNLOAD', {
                type: this.type,
                id: file.id
            }).then((response) => {
                this.$alert.info('Załączniki', 'Za chwilę zacznie się pobieranie pliku')
                setTimeout(() => {
                    FileDownload(response.data, `${file.description}.${file.extension}`);
                }, 1000)
            }).catch((error) => {
                this.$alert.error('Załączniki', error.response.data.message)
            })
        },
        humanFileSize(bytes) {
            var thresh = 1024
            if (Math.abs(bytes) < thresh) {
                return bytes + ' B'
            }
            var units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            var u = -1
            do {
                bytes /= thresh
                ++u
            } while (Math.abs(bytes) >= thresh && u < units.length - 1)
            return bytes.toFixed(1) + ' ' + units[u]
        },
    },

    components: {
        FormUpload,
        VTable,
        VBtn,
        VisitAttachmentsRemoveModal
    }
}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-field_attachments {
    margin-bottom: 4rem;

    &__title {
        margin-bottom: 2rem;
    }
    &__upload {
        display: flex;
        width: 100%;
        justify-content: center;
    }
    &__list {
        margin-top: 2rem;

        &-btns button {
            margin-right: 0.5rem;

            &:last-of-type {
                margin-right: 0;
            }
        }
    }
}

</style>

